import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { SoundManager } from '../lib/SoundManager';

const SoundContext = createContext({
  muted: false,
  toggleMute: () => {},
  playSound: () => {},
  playGameMusic: () => {},
  stopMusic: () => {},
});

export function SoundProvider({ children }) {
  const [muted, setMuted] = useState(false);
  
  const toggleMute = useCallback(() => {
    const newMuted = SoundManager.toggleMute();
    setMuted(newMuted);
  }, []);
  
  const playSound = useCallback((name) => {
    SoundManager.play(name);
  }, []);

  const playGameMusic = useCallback((gameKey) => {
    SoundManager.playGameMusic(gameKey);
  }, []);

  const stopMusic = useCallback(() => {
    SoundManager.stopMusic();
  }, []);

  return (
    <SoundContext.Provider value={{ muted, toggleMute, playSound, playGameMusic, stopMusic }}>
      {children}
    </SoundContext.Provider>
  );
}

export function useSound() {
  return useContext(SoundContext);
}
